var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmailPreview',{attrs:{"title":"Reward loyalty after checkout","subject":"\n    You just earned Coins\n  ","previewText":"Collect your Loyalty Reward"}},[_c('CustomerAcquisitionEmailPreview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }